export default __webpack_public_path__ + "static/media/authantic-embossed-texture.eeab6c84.svg";